module.exports = __webpack_public_path__ + "static/img/golang.f187d47.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/golang.jpeg
// module id = 3Gel
// module chunks = 1